<div class="buttons">
    <div class="popup-button"
         *ngFor="let rk of rangeKeys">
        <aa-popup-button [rangeKey]="rk"
                         (buttonClicked)="onButtonClicked($event)">
        </aa-popup-button>
    </div>
</div>
